export const environment = {
  production: true,
  projectID: "psicologia",
  defaultauth: "fake-backend",
  databaseName: "contenidov1",
  endpoint: "https://dbappwrite.psicologa.co/v1",
  bucketFotosEspecialistas: "fotos_especialistas",
  bucketDocumentosEmpresas: "documentos_empresas",
  bucketDocumentosEspecialistas: "documentos_especialista",
  bucketDocumentosGenerales: "documentos_generales",
  bucketFirmaEspecialistas: "firma_especialistas",
  bucketDocumentosPacientes: "documentos_pacientes",
  bucketDocumentosHistoria: "documentos_historia_clinica",
  imageUserDefault: "/assets/images/users/default.jpg",
  urlImages: "https://dbappwrite.psicologa.co/v1/storage/buckets/",
  apiCountries: "https://dbappwrite.psicologa.co/v1/locale/countries",
  apiSendMail: "https://apis.psicologa.co/sendmail",
  apiStates: "https://apis.psicologa.co",
  urlSiteAdmin: "https://admin.psicologa.co/",
  urlSitePacientes: "https://app.psicologa.co/",
  wsUrl: "wss://apis.psicologa.co",
  wompi: {
    privateKey: "prv_prod_EdtEeJsHflAwmo9Mq2kELwK4YEA8Jgwg",
    publicKey: "pub_prod_awzyV3uM1N7TTf1LRpJ1F5YyKVTnegMe",
    testIntegrity: "prod_integrity_SvzJXwm3vDlY6GQFbukXTAf29Q0KVOR9",
    currency: "COP",
  },
  language: {
    processing: "Procesando...",
    search: "Buscar:",
    lengthMenu: "Mostrar _MENU_ elementos",
    info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
    infoEmpty: "Mostrando ningún elemento.",
    infoFiltered: "(filtrado _MAX_ elementos total)",
    infoPostFix: "",
    loadingRecords: "Cargando registros...",
    zeroRecords: "No se encontraron registros",
    emptyTable: "No hay datos disponibles en la tabla",
    paginate: {
      first: "Primero",
      previous: "Anterior",
      next: "Siguiente",
      last: "Último",
    },
    aria: {
      sortAscending: ": Activar para ordenar la tabla en orden ascendente",
      sortDescending: ": Activar para ordenar la tabla en orden descendente",
    },
  },
  firebaseConfig: {
    apiKey: "",
    authDomain: "",
    databaseURL: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: "",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
